// Default production API URL - can be overridden with REACT_APP_API_BASE_URL or REACT_APP_API_URL
const PRODUCTION_API_URL = 'https://lead-api.naturatherapy.rs';

const PRODUCTION_FRONTENDS = new Set([
  'lead-monitoring-natura-therapy-fron.vercel.app',
  'lead-monitoring-natura-therapy-frontend.vercel.app',
]);

const LOCAL_FALLBACK_PORT = 3401;

const normalizeHostname = (hostname: string) => hostname.trim().toLowerCase();

export const resolveApiBaseUrl = (): string => {
  // Check for environment variable (REACT_APP_API_BASE_URL takes precedence, then REACT_APP_API_URL for backward compatibility)
  const envValue = process.env.REACT_APP_API_BASE_URL?.trim() || process.env.REACT_APP_API_URL?.trim();
  if (envValue) {
    return envValue;
  }

  if (typeof window === 'undefined') {
    return PRODUCTION_API_URL;
  }

  const { protocol, hostname, port } = window.location;
  const normalizedHost = normalizeHostname(hostname);

  if (!hostname) {
    return PRODUCTION_API_URL;
  }

  // For production frontends, use the production API URL
  if (PRODUCTION_FRONTENDS.has(normalizedHost)) {
    return PRODUCTION_API_URL;
  }

  // For HTTPS in production, use the production API URL
  if (protocol === 'https:' && (normalizedHost.includes('naturatherapy') || normalizedHost.includes('natura'))) {
    return PRODUCTION_API_URL;
  }

  // For localhost development, always use the backend port (not the frontend port)
  // Frontend runs on 3400, backend runs on 3401
  if (normalizedHost === 'localhost' || normalizedHost === '127.0.0.1' || normalizedHost.startsWith('192.168.')) {
    return `${protocol}//${hostname}:${LOCAL_FALLBACK_PORT}`;
  }

  // For other local development, use the same host with backend port
  const effectivePort = port || LOCAL_FALLBACK_PORT.toString();
  return `${protocol}//${hostname}:${effectivePort}`;
};

export const API_BASE_URL = resolveApiBaseUrl();

